import ACTIONS, { FETCH_STATUS } from "../constants";

export const showMessageBox = (data) => ({
  type: ACTIONS.SHOW_MESSAGE_BOX,
  data,
});

export const getDashboardSummaryAttempt = {
  pending: {
    type: ACTIONS.DASHBOARD_SUMMARY.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DASHBOARD_SUMMARY.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DASHBOARD_SUMMARY.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getDashboardSummaryRequest = () => ({
  type: ACTIONS.DASHBOARD_SUMMARY_CALL,
});

export const getSettingsRequestAttempt = {
  pending: {
    type: ACTIONS.ACCOUNT_SETTINGS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.ACCOUNT_SETTINGS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.ACCOUNT_SETTINGS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getSettingsRequest = (state) => ({
  type: ACTIONS.ACCOUNT_SETTINGS_CALL,
  payload: state,
});

export const updateAccountSettingsAttempt = {
  pending: {
    type: ACTIONS.UPDATE_ACCOUNT_SETTINGS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_ACCOUNT_SETTINGS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_ACCOUNT_SETTINGS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateAccountSettings = (state) => ({
  type: ACTIONS.UPDATE_ACCOUNT_SETTINGS_CALL,
  payload: state,
});

export const updateLogoAttempt = {
  pending: {
    type: ACTIONS.UPDATE_ACCOUNT_LOGO.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_ACCOUNT_LOGO.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_ACCOUNT_LOGO.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateLogo = (state) => ({
  type: ACTIONS.UPDATE_ACCOUNT_LOGO_CALL,
  payload: state,
});

export const createReminderAttempt = {
  pending: {
    type: ACTIONS.CREATE_REMINDER.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CREATE_REMINDER.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.CREATE_REMINDER.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const createReminderRequest = (state) => ({
  type: ACTIONS.CREATE_REMINDER_CALL,
  payload: state,
});

export const updateReminderAttempt = {
  pending: {
    type: ACTIONS.UPDATE_REMINDER.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_REMINDER.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_REMINDER.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updateReminderRequest = (state) => ({
  type: ACTIONS.UPDATE_REMINDER_CALL,
  payload: state,
});

export const clearReminder = () => ({
  type: ACTIONS.CLEAR_REMINDER,
});

export const getRemindersAttempt = {
  pending: {
    type: ACTIONS.GET_REMINDERS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.GET_REMINDERS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.GET_REMINDERS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getReminders = (state) => ({
  type: ACTIONS.GET_REMINDERS_CALL,
  payload: state,
});

export const fetchReminderAttempt = {
  pending: {
    type: ACTIONS.FETCH_REMINDER.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.FETCH_REMINDER.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.FETCH_REMINDER.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const fetchReminderRequest = (state) => ({
  type: ACTIONS.FETCH_REMINDER_CALL,
  payload: state,
});

export const deleteReminderAttempt = {
  pending: {
    type: ACTIONS.DELETE_REMINDER.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DELETE_REMINDER.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DELETE_REMINDER.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const deleteReminderRequest = (state) => ({
  type: ACTIONS.DELETE_REMINDER_CALL,
  payload: state,
});

export const markReminderReadAttempt = {
  pending: {
    type: ACTIONS.MARK_REMINDER_READ.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.MARK_REMINDER_READ.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.MARK_REMINDER_READ.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const markReminderReadRequest = (state) => ({
  type: ACTIONS.MARK_REMINDER_READ_CALL,
  payload: state,
});

export const setReminderSnoozeAttempt = {
  pending: {
    type: ACTIONS.REMINDER_SNOOZE.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.REMINDER_SNOOZE.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.REMINDER_SNOOZE.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const setReminderSnooze = (state) => ({
  type: ACTIONS.REMINDER_SNOOZE_CALL,
  payload: state,
});

export const getNotificationsAttempt = {
  pending: {
    type: ACTIONS.GET_NOTIFICATIONS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.GET_NOTIFICATIONS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.GET_NOTIFICATIONS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getNotifications = () => ({
  type: ACTIONS.GET_NOTIFICATIONS_CALL,
});

export const deleteNotificationAttempt = {
  pending: {
    type: ACTIONS.DELETE_NOTIFICATION.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DELETE_NOTIFICATION.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DELETE_NOTIFICATION.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const deleteNotificationRequest = (state) => ({
  type: ACTIONS.DELETE_NOTIFICATION_CALL,
  payload: state,
});

export const markNotificationReadAttempt = {
  pending: {
    type: ACTIONS.MARK_NOTIFICATION_READ.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.MARK_NOTIFICATION_READ.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.MARK_NOTIFICATION_READ.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const markNotificationReadRequest = (state) => ({
  type: ACTIONS.MARK_NOTIFICATION_READ_CALL,
  payload: state,
});

export const showToast = (data) => ({
  type: ACTIONS.ADD_TOAST_IN_LIST,
  data,
});

export const showNotificationToast = (data) => ({
  type: ACTIONS.NOTIFICATION_TOAST,
  data,
});

export const removeToast = () => ({
  type: ACTIONS.REMOVE_TOAST_IN_LIST,
  data: "",
});

export const updateNavExpand = () => ({
  type: ACTIONS.UPDATE_NAV_EXPAND,
});

export const closeModalRequest = (data) => ({
  type: ACTIONS.CLOSE_MODAL,
  data,
});

export const setNotification = (data) => ({
  type: ACTIONS.NOTIFICATIONS,
  data,
});

export const setReminder = (data) => ({
  type: ACTIONS.REMINDERS,
  data,
});

export const setResExp = (data) => ({
  type: ACTIONS.EXP_RES,
  data,
});
export const setResClients = (data) => ({
  type: ACTIONS.EXP_CLIENTS,
  data,
});
export const setResMeetings = (data) => ({
  type: ACTIONS.EXP_MEETINGS,
  data,
});
export const setResProjects = (data) => ({
  type: ACTIONS.EXP_PROJECTS,
  data,
});

export const getPJMDashboardSummaryAttempt = {
  pending: {
    type: ACTIONS.PJM_DASHBOARD_SUMMARY.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.PJM_DASHBOARD_SUMMARY.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.PJM_DASHBOARD_SUMMARY.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getPJMDashboardSummaryRequest = () => ({
  type: ACTIONS.PJM_DASHBOARD_SUMMARY_CALL,
});

export const getPJMDashboardDetailAttempt = {
  pending: {
    type: ACTIONS.PJM_DASHBOARD_DETAIL.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.PJM_DASHBOARD_DETAIL.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.PJM_DASHBOARD_DETAIL.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getPJMDashboardDetailRequest = (projectId) => ({
  type: ACTIONS.PJM_DASHBOARD_DETAIL_CALL,
  projectId,
});

export const getPRMDashboardSummaryAttempt = {
  pending: {
    type: ACTIONS.PRM_DASHBOARD_SUMMARY.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.PRM_DASHBOARD_SUMMARY.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.PRM_DASHBOARD_SUMMARY.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getPRMDashboardSummaryRequest = () => ({
  type: ACTIONS.PRM_DASHBOARD_SUMMARY_CALL,
});

export const getPRMDashboardDetailAttempt = {
  pending: {
    type: ACTIONS.PRM_DASHBOARD_DETAIL.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.PRM_DASHBOARD_DETAIL.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.PRM_DASHBOARD_DETAIL.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getPRMDashboardDetailRequest = (programId) => ({
  type: ACTIONS.PRM_DASHBOARD_DETAIL_CALL,
  programId,
});

export const clearPRMDashboardData = (state) => ({
  type: ACTIONS.CLEAR_PRM_DASHBOARD_DATA,
}); 

export const clearPJMDashboardData = (state) => ({
  type: ACTIONS.CLEAR_PJM_DASHBOARD_DATA,
}); 

export const getPOMDashboardSummaryAttempt = {
  pending: {
    type: ACTIONS.POM_DASHBOARD_SUMMARY.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.POM_DASHBOARD_SUMMARY.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.POM_DASHBOARD_SUMMARY.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getPOMDashboardSummaryRequest = () => ({
  type: ACTIONS.POM_DASHBOARD_SUMMARY_CALL,
});

export const getPOMDashboardDetailAttempt = {
  pending: {
    type: ACTIONS.POM_DASHBOARD_DETAIL.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.POM_DASHBOARD_DETAIL.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.POM_DASHBOARD_DETAIL.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getPOMDashboardDetailRequest = (portfolioId) => ({
  type: ACTIONS.POM_DASHBOARD_DETAIL_CALL,
  portfolioId,
});

export const clearPOMDashboardData = () => ({
  type: ACTIONS.CLEAR_POM_DASHBOARD_DATA,
});